// extracted by mini-css-extract-plugin
export default {"cover":"palI3GBNLpwYPoxpE6G1","mosaic":"RUxy7uiZmgsKjYNutsRx","fallback":"HI0nI3WywIwQL7sygTPy","mosaicCell":"EXUbG2JTXoV3RupBWXD8"};